export const timeRange = {
  'In Past 24 Hours': 1,
  'In Past 7 Days': 7,
  'In Past 30 Days': 30,
  'In Past 60 Days': 60,
};
